import { textLengthFast } from "../../../lib/wordGenerator/textLength";
import { LengthFilter } from "../../../param/generalSearchFilter";
import { filter } from "../commonLoop";
import { Result } from "../generalSearchResult";

export const lengthFilter = async ({
  query,
  result,
  workerContext,
}: {
  query: LengthFilter;
  result: Result;
  workerContext: any;
}) => {
  const minLength = query.minLength ?? "";
  const maxLength = query.maxLength ?? "";

  return filter(workerContext, result, (e) => {
    return (
      (minLength === "" || textLengthFast(e.currentWord) >= minLength) &&
      (maxLength === "" || textLengthFast(e.currentWord) <= maxLength)
    );
  });
};
